import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapHighHandDoc } from "src/utils/mapHighHand";

/**
 * @param {string} slug - localized URL segment (e.g. `high-hand-summer-2026`)
 * @param {string} locale - `en` | `fr`
 * @param {{ draft?: boolean, depth?: number }} [options]
 * @returns {Promise<ReturnType<typeof mapHighHandDoc> | null>}
 */
export async function fetchHighHandBySlug(slug, locale, options = {}) {
  const trimmed = typeof slug === "string" ? slug.trim() : "";
  if (!trimmed) return null;

  const lang = locale === "fr" ? "fr" : "en";
  const depth = options.depth ?? 2;

  const url = buildPayloadApiUrl("/api/high-hand-promotions", {
    locale: lang,
    limit: 1,
    depth,
    "where[slug][equals]": trimmed,
    ...(options.draft ? { draft: true } : {}),
  });

  const response = await payloadFetch(url);
  const doc = response?.docs?.[0];
  if (!doc) return null;
  return mapHighHandDoc(doc, lang);
}

/**
 * @param {string|number} id
 * @param {string} locale
 * @param {{ draft?: boolean, depth?: number }} [options]
 * @returns {Promise<ReturnType<typeof mapHighHandDoc> | null>}
 */
export async function fetchHighHandById(id, locale, options = {}) {
  if (id == null || id === "") return null;

  const lang = locale === "fr" ? "fr" : "en";
  const depth = options.depth ?? 2;

  const url = buildPayloadApiUrl(`/api/high-hand-promotions/${id}`, {
    locale: lang,
    depth,
    ...(options.draft ? { draft: true } : {}),
  });

  const doc = await payloadFetch(url);
  if (!doc?.id && !doc?.promotionKey) return null;
  return mapHighHandDoc(doc, lang);
}
